import React, { useContext, Fragment, useEffect } from "react";
import { FiltroDeDadosContext } from "../FiltroDeDadosContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarFiltroDeDados = () => {
  const { values, setValues, resetScreen } = useContext(FiltroDeDadosContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={FiltroDeDadosContext}>
        <div className="col-12 col-md-4">
          <label>Nome do Filtro</label>
          <input
            className="form-control"
            type="text"
            name="filtroDeDadosNome"
            value={values.searchData.filtroDeDadosNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={FiltroDeDadosContext} />
    </Fragment>
  );
};

export default PesquisarFiltroDeDados;
